import React from 'react'
import styles from './NavbarLink.module.css'
const NavbarLink = (props) => {
    return (
        <div className={styles.navbar}>
            <svg viewBox="0 0 512 512">
                <path d={props.path}></path>
            </svg>
            <h5>{props.name}</h5>
        </div>
    );
}

export default NavbarLink

